export const SEARCH_KEY = 'fullname_or_email'

export const API_PARAMS = { page_size: 40, redesign: 1, with_providers: 1 }

export const MIN_SEARCH_STRING_SIZE = 3

export const MAX_HEIGHT_FOR_SHOW_MORE_BTN = 80
